module.exports = __webpack_public_path__ + "img/topic_conflict.1b7bd81c.svg";